<template>
  <div>
    <v-dialog/>
    <div class="task_kaoshi_list">
      <h5 class="none_ts" v-if="userOrders.length == 0" style="text-align: center;">
        <img src="@/assets/images/none_data.jpg" alt="">
      </h5>
      <dl v-if="userOrders.length > 0" v-for="item in userOrders" :key="item.id">
        <dt>
          <span v-if="item.orderid">订单编号：{{item.orderId}}</span>
          <span>
            <span v-if="item.payDate">付款日期：{{ dateFormat(new Date(item.payDate), 'yyyy-MM-dd hh:mm:ss') }}</span>
            <b>{{item.paystateName}}</b>
            <b>{{item.stateName}}</b>
          </span>
        </dt>
        <dd>
          <img v-if="item.cover" :src="item.cover" class="list_img" />
          <img v-if="!item.cover" src="@/assets/images/test_img.jpg" class="list_img" />
          <h3>
            {{item.name}}
            <span v-if="item.type == '01'" style="display: inline-block; font-size: 14px; line-height: 14px; background: #ff3633; border-radius: 5px; color: white; padding: 5px;">线上课程</span>
            <span v-if="item.type == '02'" style="display: inline-block; font-size: 14px; line-height: 14px; background: #ff3633; border-radius: 5px; color: white; padding: 5px;">直播</span>
            <span v-if="item.type == '03'" style="display: inline-block; font-size: 14px; line-height: 14px; background: #ff3633; border-radius: 5px; color: white; padding: 5px;">计划</span>
            <span v-if="item.type == '04'" style="display: inline-block; font-size: 14px; line-height: 14px; background: #ff3633; border-radius: 5px; color: white; padding: 5px;">线下课程</span>
          </h3>
          <!--<h4>
            <span>报名开始时间：{{item.signupinfo.starttime}}&#45;&#45;报名结束时间：{{item.signupinfo.endtime}}</span>
            <span v-if="item.type == '04'">授课开始时间：{{item.signupinfo.lectureStartTime}} &#45;&#45; 授课结束时间：{{item.signupinfo.lectureEndTime}} </span>
          </h4>-->
          <p @click="go2Info(item)" style="font-size: 0.8em; position: absolute; top: 62px; left: 236px;text-decoration: underline; cursor: pointer;">点击查看报名详情</p>
          <p class="price_a" v-if="item.cost > 0">¥<span>{{item.cost}}</span>元</p>
          <p class="price_a" v-if="item.cost == 0"><span>免费</span></p>
          <a href="javascript:;" class="go_btn" v-if="(item.type !== '04') && item.state == '1' || item.paystate=='1'" @click="goCheck(item)">开始学习</a>
          <a href="javascript:;" class="go_btn" v-if="item.paystate=='0' || item.paystate=='2'" @click="continuePay(item)">继续支付</a>
          <a href="javascript:;" class="reset_btn" v-if="item.paystate=='0' || item.paystate=='2'" @click="cancelOrder(item.id)">取消订单</a>
        </dd>
      </dl>
    </div>
    <div v-if="userOrders.length > 0" class="zy_list_bottom mtf30">
      <dl>
        <dd>
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
  </div>
</template>
<script>
  import config from '@/config'
  import api from '@/api'
  import Paginate from 'vuejs-paginate'
  import { getCookie } from '@/store/cookies.js'
  export default {
    components: { Paginate },
    data () {
      return {
        orgType: null,
        originPath: window.location.href,
        filter: {
          pageNo: 1,
          pageSize: 3,
          delFlag: '0'
        },
        userOrders: [],
        orderCnt: 0,
        pages: 0,
        ori_str: '',
        prefix: this.$route.meta.prefix || ''
      }
    },
    created () {
      if (getCookie('org') && getCookie('org').businessId) { this.orgType=getCookie('org').businessId }
      this.ori_str = this.$utils.judgementOri(this.orgType)
      this.getUserOrders(this.filter)
    },
    methods: {
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: () => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }
            },
            {
              title: '取消'
            }
          ]
        })
      },
      clickCallback (pageNum) {
        this.filter.pageNo = pageNum
        this.getUserOrders(this.filter)
      },
      getUserOrders (filter) {
        api.post(config.enrollApiPath, '/signupuser/search', filter, (r) => {
          if (r.data && r.data.length>0) {
            this.orderCnt = r.cntData
            this.pages = Math.ceil(this.orderCnt / this.filter.pageSize)
            this.userOrders = r.data
          } else {
            this.orderCnt = 0
            this.pages = 0
            this.userOrders = []
          }
        })
      },
      goCheck (item) {
        var path = this.$OR.getUrl(getCookie('org').businessId)
        switch (item.type) {
          case '01': {
            this.$router.push({path: path + '/courseDetail/'+ item.businessId})
            break
          }
          case '02': {
            this.$router.push({path: path + '/livePlay/'+ item.businessId})
            break
          }
          case '03': {
            this.$router.push({path: path + '/plan/'+ item.businessId})
            break
          }
        }
      },
      go2Info (item) {
        this.$router.push({path: this.prefix + '/enroll/'+ item.signupid})
      },
      continuePay (item) {
        var that = this
        that.confirmBox({
          title: '继续支付',
          text: '确认继续吗？',
          yes: function () {
            var _addEnroll = function () {
              that.$api.post(that.$global.enrollApiPath, '/signupuser/save', { // 生成报名记录
                signupid: item.signupid,
                payState: '0'
              }, r => {
                if (r.data) {
                  if (item.cost > 0) { // 不免费才需要购买, 跳转至支付页面
                    that.$router.push({path: that.prefix + '/enrollPay/' + item.signupid + '/' + '1' + '/' + r.data.id + '/' + that.orgType + '/' + encodeURIComponent(window.location.href) + '/' + r.data.sign})
                  } else { // 免费报名成功
                    that.$modal.hide('dialog')
                    that.$toasted.show('报名成功')
                    that.search(that.filters)
                  }
                }  else {
                  that.$toasted.show('系统繁忙, 请稍后再试')
                }
              })
            }
            that.$api.post(that.$global.paymentApiPath, '/paycenter/orderCancel', {businessId: item.id}, r => {
              that.$api.get(that.$global.enrollApiPath, '/signupuser/delete', {id: item.id}, r => {
                _addEnroll()
              }, e => {
                that.$toasted.show(e.message, {
                  duration: 800
                })
              })
            }, e => {
              if (e == 'PAY_ERROR_00014') {
                that.search(that.filters)
              }
            })
          }
        })
      },
      cancelOrder (sid) {
        var that = this
        that.confirmBox({
          title: '取消订单',
          text: '确认取消吗？',
          yes: function () {
            that.$api.post(that.$global.paymentApiPath, '/paycenter/orderCancel', {businessId: sid}, r => {
              that.$api.get(that.$global.enrollApiPath, '/signupuser/delete', {id: sid}, r => {
                that.$modal.hide('dialog')
                that.$toasted.show('订单取消成功！', {
                  duration: 800
                })
                that.search(that.filters)
              }, e => {
                that.$toasted.show(e.message, {
                  duration: 800
                })
              })
            }, e => {
              if (e == 'PAY_ERROR_00014') {
                that.search(that.filters)
              }
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/modules/uc/enroll.vue